import { render } from "./narvar.vue?vue&type=template&id=2619a4d8&scoped=true"
import script from "./narvar.vue?vue&type=script&lang=js"
export * from "./narvar.vue?vue&type=script&lang=js"

import "./narvar.vue?vue&type=style&index=0&id=2619a4d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2619a4d8"]])

export default __exports__